module.exports = __webpack_public_path__ + "static/media/icon-piece2-2.e84f7b5c.png";